import { createAction, props } from '@ngrx/store';
import { SciMenuListado } from '../models/SciMenuListado';

export const cargarMenu = createAction('[Menu] Cargar Menu');

export const cargarMenuSuccess = createAction('[Menu] Cargar Menu Success', props<{ sciMenu: SciMenuListado[] }>());

export const cargarMenuError = createAction('[Menu] Cargar Menu Error', props<{ payload: any }>());
